import { useEffect, useRef, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore, API_BASE, apiFetch } from '../store/auth'

export default function ProtectedRoute() {
  const { user, setUser, setOrganizations, setActiveOrg, logout, setLoading } = useAuthStore()
  const [checked, setChecked] = useState(false)
  const initialized = useRef(false)

  // On mount, try to restore session from cookie
  useEffect(() => {
    if (initialized.current) return
    initialized.current = true

    setLoading(true)
    apiFetch(`${API_BASE}/auth/me`)
      .then((r) => {
        if (!r.ok) throw new Error('Session expired')
        return r.json()
      })
      .then((data) => {
        setUser(data.user)
        setOrganizations(data.organizations ?? [])
        if (data.organizations?.length > 0) {
          let savedOrgId: string | null = null
          try { savedOrgId = localStorage.getItem('activeOrgId') } catch {}
          const savedOrg = savedOrgId ? data.organizations.find((o: { id: string }) => o.id === savedOrgId) : null
          setActiveOrg(savedOrg || data.organizations[0])
        }
        setLoading(false)
        setChecked(true)
      })
      .catch(() => {
        logout()
        setLoading(false)
        setChecked(true)
      })
  }, [setUser, setOrganizations, setActiveOrg, logout, setLoading])

  // Show nothing while checking
  if (!checked) return null

  // If no user after checking, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
